var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 6.286a.853.853 0 00.611.812l4.987.43.43 4.986a.853.853 0 00.812.611h.016a.853.853 0 00.815-.577l3.53-9.517a.865.865 0 00-1.096-1.11l-.01.003-9.517 3.53a.854.854 0 00-.578.832z",
    fill: "#2355FC"
  })));
}

export default SvgLocationArrow;